var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h3 text-center"},[(_vm.isLoading)?_c('div',{staticClass:"row justify-content-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Please wait"}}),_c('span',{staticClass:"ms-3 mt-1"},[_vm._v("Loading ... Please wait")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }